import type { ReactNode, CSSProperties } from "react";
import React from "react";

import { styled } from "styled-components";

import { gridSpacing, colorTheme } from "@utils";

import CopyButton from "../CopyButton";
import InfoTooltip from "../InfoTooltip/InfoTooltip";

export const InfoTextWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${gridSpacing[3]}px;
`;

interface InfoTextProps {
  title?: string;
  titleTooltip?: string;
  content?: ReactNode;
  contentStyle?: CSSProperties;
  text?: string | null;
  style?: CSSProperties;
  cleanText?: boolean;
  testId?: string;
  children?: ReactNode;
  small?: boolean;
  copyValue?: string | null;
}

const InfoText = ({
  title,
  titleTooltip,
  content,
  contentStyle,
  text,
  style,
  cleanText,
  testId,
  children,
  small = false,
  copyValue,
}: InfoTextProps) => {
  if (text) {
    if (cleanText) {
      text = text.replaceAll("_", " ");
    }

    content = text;
  }

  if (cleanText && content && typeof content === "string") {
    content = content.replaceAll("_", " ");
  }

  return (
    <div
      style={{
        marginTop: gridSpacing[3],
        marginBottom: gridSpacing[3],
        ...style,
      }}
    >
      <p
        style={{
          color: colorTheme("neutralL1"),
          marginBottom: small ? 0 : gridSpacing[1],
          fontSize: small ? 12 : 14,
        }}
      >
        {title}
        {titleTooltip && (
          <InfoTooltip
            ml
            text={titleTooltip}
            style={{ display: "inline-block" }}
          />
        )}
      </p>
      {children ? (
        children
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: copyValue ? gridSpacing[1] : 0,
          }}
        >
          <div
            style={{
              textTransform: cleanText ? "capitalize" : "none",
              overflowWrap: "break-word",
              fontSize: small ? 14 : 16,
              overflow: "hidden",
              ...contentStyle,
            }}
            data-testid={testId}
          >
            {content || "-"}
          </div>
          {copyValue && content && <CopyButton value={copyValue} />}
        </div>
      )}
    </div>
  );
};

export default InfoText;
